/**
 * ページテンプレートIDVO
 *
 * @export PageTemplateIDModel
 * @class PageTemplateIDModel
 */
export class PageTemplateIDModel {
  // 媒体グループID
  public pageTemplateID: string = null;
}
